<!--
component: SearchNo
author: Ken Nakamura
description: 番号検索画面
-->
<template>
  <section class="search-no">
    <div class="head-message">
      {{ headMessage }}
    </div>
    <v-container fluid>
      <v-row>
        <v-col sm=12 md=6 lg=6 xl=6>
          <v-row>
            <v-col cols=6>
              <v-btn
                @click="inputMode=0"
                large width="95%"
                class="lighten-4 text-h6 my-2 blue"
                :class="{yellow: inputMode==0}" >
                年度
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col cols=1></v-col>  -->
            <v-col cols=6>
              <div align="center">
              <v-btn-toggle v-model="era" mandatory background-color="white">
                <v-btn active-class="light-blue darken-3 white--text" :value="0" v-if="mode != 7">昭和</v-btn>
                <v-btn active-class="light-blue darken-3 white--text" :value="1">平成</v-btn>
                <v-btn active-class="light-blue darken-3 white--text" :value="2">令和</v-btn>
              </v-btn-toggle>
              </div>
            </v-col>
            <v-col>
              <v-text-field id="text-nendo" v-model="nendoText"
                readonly solo autocomplete="off" hide-details="auto"
                @focus="inputMode=0" 
                class="text-h6 my-0"
                style="margin-right: 4em;"
              />
            </v-col>
          </v-row>
          <v-row v-show="needsWard">
            <v-col cols=6>
              <v-btn
                @click="inputMode=1"
                large width="95%"
                class="lighten-4 text-h6 my-2 blue"
                :class="{yellow: inputMode==1}" >
                区
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field id="text-ward" v-model="wardName"
                readonly solo autocomplete="off" hide-details="auto"
                @focus="inputMode=1" 
                class="text-h6 my-2"
                style="margin-right: 4em;"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols=6>
              <v-btn
                @click="inputMode=2"
                large width="95%"
                class="lighten-4 text-h6 my-2 blue"
                :class="{yellow: inputMode==2}" >
                番号
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field id="text-bango" v-model="bango" ref="bango"
                type="tel" hide-spin-buttons
                solo autocomplete="off" hide-details="auto"
                @focus="inputMode=2" 
                class="text-h6 my-2"
                style="margin-right: 4em;"
              />
            </v-col>
          </v-row>
          
          <!-- 開発・造成・土石の堆積（旧 開発・宅造）閲覧の場合 -->
          <v-row class="mt-2" v-show="mode==5"> 
            <v-col cols="4">
              <kaihatsu-type-selector 
                v-model="targetKaihatsuType"
              />
            </v-col>
          </v-row>
          
          <v-row class="mt-2"> 
            <v-col cols="4" v-show="kosakuVisible">
              <v-btn-toggle v-model="targetType" mandatory background-color="white">
                <v-btn active-class="light-blue darken-3 white--text" :value="0">建築物</v-btn>
                <v-btn active-class="light-blue darken-3 white--text" :value="1">工作物</v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col>
              <v-btn
                @click="search()"
                :disabled="cannotSearch"
                primary x-large width="80%"
                class="text-h4 mx-2 my-4">
                <v-icon color="#446666" class="mx-1">mdi-database-search</v-icon>
                検 索
              </v-btn>
            </v-col>
          </v-row>
          <!--
          <v-row>
            <v-btn
              @click="search()"
              :disabled="cannotSearch"
              primary large width="90%"
              class="text-h6 my-2" >
              検索
            </v-btn>
          </v-row>
          -->
        </v-col>
        <v-col sm=12 md=6 lg=6 xl=6>
          <year-button-pad @selectNendo="selectNendo" :era=3 v-show="inputMode==0 && era==0" />
          <year-button-pad @selectNendo="selectNendo" :era=4 v-show="inputMode==0 && era==1" />
          <year-button-pad @selectNendo="selectNendo" :era=5 :wareki="mode!=5" v-show="inputMode==0 && era==2" />
          <!-- NT保留
          <ward-button-pad @selectWard="selectWard" :ntVisible="mode==5" v-show="inputMode==1" />
          -->
          <ward-button-pad @selectWard="selectWard" v-show="inputMode==1"
            :ntVisible="ntVisible && mode==5" />
          <tenkey-pad @pushed="tenkeyPushed" @clear="clearNo" v-show="inputMode==2" />
        </v-col>
      </v-row>
    </v-container>
    <Dialog search :open="searching" :cancel="cancelDialog" title="検索中" />
    <Dialog error :open="notfound" :ok="closeDialog" title="番号検索" body="指定された番号が見つかりません" />
    <Dialog message :open="canceled" :ok="closeDialog" title="番号検索" body="キャンセルされました" />
		<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
  </section>
</template>

<script>
import YearButtonPad from '../components/YearButtonPad.vue'
import WardButtonPad from '../components/WardButtonPad.vue'
import TenkeyPad from '../components/TenkeyPad.vue'
import Dialog from '../components/Dialog.vue'
import KaihatsuTypeSelector from '../components/kaihatsu/KaihatsuTypeSelector.vue'
import { dbglog, /* getWardName, yearToNendo*/ } from '../common/utils.js'
import { searchGaiyo, findKaihatsu, findTakuzo, findKyoai } from '../common/apiAccess.js'

export default {
  components: {
    YearButtonPad,
    WardButtonPad,
    TenkeyPad,
    Dialog,
    KaihatsuTypeSelector,
  },
  data: () => {
    return {
      inputMode: 0,
      era: 1,
      notfound: false,
      searching: false,
      canceled: false,
      controller: null,
      targetType: 0,
      ntVisible: true,
      authDialog: false,
    }
  },
  props: {
  },
  mounted () {
    if (this.unauthorized) {
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 3);
    this.message = this.searchTarget + '番号検索';
    this.inputMode = 0;
    this.era = this.$store.state.searchEra;
  },
  watch: {
    era (newValue, oldValue) {
      if (newValue != oldValue) {
        this.inputMode = 0;
        this.$store.commit('setSearchEra', newValue);
      }
    },
    targetType (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$store.commit('setSearchTargetType', newValue);
      }
    },
    bango: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          if (this.$refs.bango && this.$refs.bango.lazyValue !== undefined)
            this.$refs.bango.lazyValue = val;
          this.bango = val;
        }
      }
    },
  },
  computed: {
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    authority () {
      return this.$store.state.userInfo.authority;
    },
    wardCode: {
      /*
      get() { return this.$store.state.wardCode; },
      set(val) { this.$store.commit('setWard', val); }
      */
      get() {
        return this.$store.state.ward ? this.$store.state.ward.code : 0; 
      }
    },
    wardName () {
      return this.$store.state.wardName;
    },
    nendo: {
      get() { return this.$store.state.searchNendo; },
      set(val) { this.$store.commit('setSearchNendo', val); }
    },
    nendoText () {
      return (this.nendo !== null && this.nendo.capt !== undefined) ? this.nendo.capt : '';
    },
    bango: {
      get() { return this.$store.state.searchBango; },
      set(val) { this.$store.commit('setSearchBango', val); }
    },
    nendoEnable () {
      return this.nendo !== null && this.nendo.capt !== undefined;
    },
    needsWard () {
      return this.mode != 1 ||
       (this.nendo !== null && this.nendo.year !== undefined && this.nendo.year < 2006);
    },
    wardEnable () {
      return this.wardCode >= 14100 && this.wardCode <= 14118;
    },
    bangoEnable () {
      return this.bango > 0;
    },
    cannotSearch () {
      return !this.nendoEnable ||
        (this.needsWard && !this.wardEnable) ||
        !this.bangoEnable;
    },
    kosakuVisible () {
      //ToDo: 工作物閲覧可能年度にも対応
      return this.mode==1 && this.authority>2 && this.authority!=4;
    },
    headMessage () {
      switch (this.inputMode) {
      case 0:
        return '年度を選択してください';
      case 1:
        return '区を選択してください';
      case 2:
        return '番号を入力して下さい';
      default:
        return '';
      }
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
    searchTarget () {
        switch (this.mode) {
        case 1:
          return '建築計画概要書';
        case 2:
          return '昇降機台帳';
        case 3:
          return '定期報告概要書';
        case 4:
          return '位置指定道路';
        case 5:
          // 旧：開発・宅造 フォルダ名などの変更はバッチファイルなどの不具合が予想されるため保留  
          return '開発・造成・土石の堆積';
        case 7:
          return '狭あい道路';
        default:
          return '';
        }
    },
    targetKaihatsuType: {
      get() {
        console.log('get targetKaihatsuType:', this.$store.state.searchTargetKaihatsuType);
        return this.$store.state.searchTargetKaihatsuType;
      },
      set(value) {
        console.log('set targetKaihatsuType:', value);
        this.$store.commit('setSearchTargetKaihatsuType', value);
      }
    },
  },
  methods: {
    selectNendo(year) {
      this.nendo = year;
      if (this.mode == 1 && year.year > 2005) {
        this.$store.commit('setWard', null);
      }
    },
    selectWard(ward) {
      this.$store.commit('setWard', ward);
      //this.wardCode = code;
      //this.wardName = getWardName(code);
    },
    tenkeyPushed(n) {
      this.bango = this.bango * 10 + n;
    },
    clearNo() {
      this.bango = '';
    },
    closeDialog() {
      this.searching = false;
      this.notfound = false;
      this.canceled = false;
    },
    cancelDialog() {
      if (this.controller !== undefined && this.controller !== null) {
        this.controller.abort();
      }
      this.searching = false;
    },
    search() {
      if (this.mode == 1) {
        // 建築計画概要書閲覧
        let ward = this.wardName;
        if (!this.needsWard) {
          ward = '';
        }
        this.searching = true;
        //ToDo: targetType=1のとき工作物検索
        searchGaiyo(this.nendo.capt, ward, this.bango, (data) => {
          this.searching = false;
          if (data.length !== undefined && data.length > 0) {
            if (data.length == 1 && data[0].daichoId !== undefined) {
              /*
              if (data[0].gaiyoRec && data[0].gaiyoRec.torisagE_KUBUN) {
                this.unbrowsableReason = '取下げにつき閲覧できません。';
                this.unbrowsable = true;
                return;
              }
              else if (data[0].gaiyoRec && data[0].gaiyoRec.toriyamE_KUBUN) {
                this.unbrowsableReason = '取止めにつき閲覧できません。';
                this.unbrowsable = true;
                return;
              }
              */
              /*
              else if (data[0].gaiyoRec && (data[0].gaiyoRec.snS_KUBUN == 2)) {
                if (this.gaiyo.gaiyoRec.kknN_DAY < constants.keitsuDate) {
                  this.unbrowsableReason = '指定された計画通知は、閲覧対象日以前のため閲覧できません。';
                  this.unbrowsable = true;
                  return;
                }
              }
              */
              this.$store.commit('setGaiyoId', data[0].daichoId);
              this.$store.commit('setKojiId', data[0].kojiId);
              this.$store.commit('setUkeDay', data[0].ukeDay); //20240929 追加
              //this.$router.push({ name: 'loading', params: { action: 4 }});
              this.$router.push({ name: 'loading', params: { action: 2 }});
            }
            else {
              this.$store.commit('setSummaries', data);
              this.$router.push({ name: 'list-result', params: { listId: 0 }});
            }
          }
          else {
            if (data.errorCode == 401) {
							this.authDialog = true;
            }
            else {
              this.notfound = true;
            }
          }
        });
      }
      else if (this.mode == 5) {
        // 開発・造成・土石の堆積閲覧
        let gengo = '';
        let nendo = 0;
        if (this.nendo.capt.substring !== undefined) {
          gengo = this.nendo.capt.substring(0, 1);
          nendo = this.nendo.capt.substring(1, 3);
        }
        else {
          nendo = this.nendo.capt;
        }
        dbglog(`gengo: ${gengo} nendo: ${nendo}`);
        try {
          if (this.targetKaihatsuType == 0) {
            // 開発登録簿
            findKaihatsu(gengo, nendo, this.wardCode, this.bango, (data) => {
              /*
              if (data.length !== undefined && data.length > 0 && data[0].id !== undefined) {
                this.$router.push({ name: 'browse-kaihatsu', params: { id: data[0].id }});
              }
              else {
                this.notfound = true;
              }
              */
              if (!data.length) {
                this.notfound = true;
              }
              else if (data.length == 1) {
                this.$router.push({ name: 'browse-kaihatsu', params: { id: data[0].id }});
              }
              else {
                this.$store.commit('setSummaries', data);
                this.$router.push({ name: 'list-result', params: { listId: 0 }});
              }
            });
          }
          // targetKaihatsuType 0以外は 旧宅造 + 盛土規制（宅規, 農規, 森規, 土規）
          else if (this.targetKaihatsuType !== 0) {
            // 宅造 盛土規制法の改変により、kaihatsuTypeと追加、許可番号を評価する。（例：〇〇宅規〇〇など）
            findTakuzo(gengo, nendo, this.wardCode, this.bango, this.targetKaihatsuType, (data) => {
              /*
              if (data.length !== undefined && data.length > 0 && data[0].id !== undefined) {
                this.$router.push({name:'browse-kaihatsu', params:{id:data[0].id, target:1}});
              }
              else {
                this.notfound = true;
              }
              */
              if (!data.length) {
                this.notfound = true;
              }
              else if (data.length == 1) {
                this.$router.push({ name: 'browse-kaihatsu', params: {id: data[0].id, target:1}});
              }
              else {
                this.$store.commit('setSummaries', data);
                this.$router.push({ name: 'list-result', params: { listId: 0 }});
              }
            });
          }
        }
        catch (err) {
          dbglog(`SearchNo.search(): ${err}`);
        }
      }
      else if (this.mode == 7) {
        // 狭あい道路閲覧
        if (this.nendo !== null && this.nendo.capt !== undefined) {
          const gengo = this.nendo.capt.substring(0, 1);
          const nendo = this.nendo.capt.substring(1, 3);
          dbglog(`gengo: ${gengo} nendo: ${nendo}`);
          try {
            findKyoai(gengo, nendo, this.wardCode, this.bango, (data) => {
              dbglog(data);
              console.log(data);
              if (data.length !== undefined && data.length > 0 && data[0].id !== undefined) {
                this.$router.push({ name: 'browse-kyoai', params: { id: data[0].id }});
              }
              else {
                this.notfound = true;
              }
            });
          }
          catch (err) {
            dbglog(`SearchNo.search(): ${err}`);
          }
        }
      }
    },
    handleKaihatsuTypeChange(newValue) {
      console.log('handleKaihatsuTypeChange:', newValue);
      this.targetKaihatsuType = newValue;
    },
  }
}
</script>

<style lang="scss" scoped>

.key-pad {
  background-color: #afdfdf;
}

</style>